import React from "react"
import styled from "styled-components"

import SEO from "../components/seo"

const Page = styled.div`
  display: flex;
  height: 100vh;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

const NotFoundPage = () => (
  <Page>
    <SEO title="404: Quiz not found" />
    <h1>404: Not Found</h1>
    <p>This Quiz doesn't Exist :(</p>
  </Page>
)

export default NotFoundPage
